<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <div class="hs-screen-row">
                <Input v-model="params.nickName" placeholder="昵称" clearable style="width: 200px"/>
            </div>
<!--            <div class="hs-screen-row">-->
<!--                <Select v-model="params.isDisable" placeholder="状态" clearable style="width:200px">-->
<!--                    <Option value="">全部</Option>-->
<!--                    <Option value="0">已启用</Option>-->
<!--                    <Option value="1">已禁用</Option>-->
<!--                </Select>-->
<!--            </div>-->
            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="findList">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>用户列表</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findList">
                                <Icon type="md-refresh" size="15"/>
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <!--表格数据-->
            <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

                <template slot-scope="{ row, index }" slot="isDisable">
                    <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
                    <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
                </template>

                <template slot-scope="{ row, index }" slot="integral">
                    <span v-if="!row.integral">0</span>
                    <span v-if="row.integral">{{row.integral}}</span>
                </template>

                <template slot-scope="{ row, index}" slot="isVip">
                  <Tag color="green" v-if="row.isVip === 0" size="default">否</Tag>
                  <Tag color="volcano" v-if="row.isVip === 1" size="default">是</Tag>
                </template>

                <template slot-scope="{ row }" slot="action">
                    <Button type="primary" size="small" style="margin-right: 5px" @click="showIntegralOpe(row)">积分记录
                    </Button>
<!--                    <template v-if="row.isDisable === 0">-->
<!--                        <Button type="error" size="small" style="margin-right: 5px" @click="isDisableUser(row)">禁用-->
<!--                        </Button>-->
<!--                    </template>-->
<!--                    <template v-if="row.isDisable === 1">-->
<!--                        <Button type="success" size="small" style="margin-right: 5px" @click="isDisableUser(row)">启用-->
<!--                        </Button>-->
<!--                    </template>-->
                </template>
            </Table>
            <!--分页-->
            <div class="hs-page">
                <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </div>
        </Card>

      <integral-ope ref="integralOpe" @changeDate="findList"></integral-ope>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    import integralOpe from './components/integral-ope.vue';

    export default {
        data() {
            return {
                total: 0,
                dateInit: '',
                isTableLoading: false,
                // 参数
                params: {
                    page: 1,
                    rows: 10,
                    username: '',
                    nickName: '',
                    level: '',
                    startTime: '',
                    endTime: '',
                    isDisable: '',
                },
                // 表格列
                columns: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        minWidth: 120,
                        key: 'userId'
                    },
                    {
                        title: '昵称',
                        minWidth: 180,
                        key: 'nickName'
                    },
                    {
                      title: '星标用户',
                      minWidth: 180,
                      slot: 'isVip'
                    },
                    {
                        title: '积分',
                        minWidth: 120,
                        slot: 'integral'
                    },
                    {
                        title: '状态',
                        slot: 'isDisable',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width: 150
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180,
                        align: 'center'
                    }
                ],
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '用户管理', url: '', icon: '', size: 0},
                    {name: '用户列表', url: '', icon: '', size: 0}
                ]
            }
        },
        created() {
            // 用户-列表查询
            this.findList();
        },
        methods: {
            // 用户-列表查询
            findList() {
                this.isTableLoading = true;
                this.axios.post('/user/findList', this.params).then(res => {
                    console.log(res);
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data.rows;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查询用户列表接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 是否禁用用户
            isDisableUser(row) {
                this.$Modal.confirm({
                    title: `是否${row.isDisable ? '开启' : '禁用'}用户${row.nickName}？`,
                    onOk: () => {
                        this.disableUser(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 禁用或开启用户
            disableUser(row) {
                this.$Spin.show();
                this.axios.post('/user/disableUser', {
                    userId: row.userId,
                    isDisable: row.isDisable ? 0 : 1
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findList();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '禁用用户接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.startTime = e[0];
                this.params.endTime = e[1];
            },
            // 重置筛选条件
            resetScreen() {
                this.params.nickName = '';
                this.params.isDisable = '';
                this.params.startTime = '';
                this.params.endTime = '';
                this.dateInit = '';
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findList();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findList();
            },
          // 显示操作模态框
          showIntegralOpe(row) {
            this.$refs.integralOpe.show(row);
          },
        },
        components: {
            hsBreadcrumb,
            integralOpe
        }
    }
</script>

<style scoped>

</style>